/**
 * Per-device preferences (Settings). Stored in localStorage only: nothing here
 * is synced to the server yet, so a new device starts from the defaults.
 */
import type { QualityTier } from '@loomia/shared';

export interface Prefs {
  displayName: string;
  notifyJobDone: boolean;
  notifyDaily: boolean;
  notifyNews: boolean;
  quality: QualityTier;
}

const KEY = 'loomia.prefs';
const DEFAULTS: Prefs = {
  displayName: '',
  notifyJobDone: true,
  notifyDaily: true,
  notifyNews: false,
  // 540p: sharp enough on a phone at two thirds of the 720p price (owner, 2026-10-23).
  quality: '540p',
};

export function getPrefs(): Prefs {
  try {
    const raw = localStorage.getItem(KEY);
    return { ...DEFAULTS, ...(raw ? (JSON.parse(raw) as Partial<Prefs>) : {}) };
  } catch {
    return { ...DEFAULTS };
  }
}

export function setPrefs(patch: Partial<Prefs>): Prefs {
  const next = { ...getPrefs(), ...patch };
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* private mode: preference lasts until reload */
  }
  return next;
}
